import { render, staticRenderFns } from "./TextBasedNotificationWidget.vue?vue&type=template&id=11e1cfb2&"
import script from "./TextBasedNotificationWidget.vue?vue&type=script&lang=js&"
export * from "./TextBasedNotificationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports